<h1 class="title">
  @if (type) {
    <rkt-icon [name]="type"></rkt-icon>
  }
  {{ name }}
</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>

@if (fileFormat !== 'PDF') {
  <div class="image-preview">
    @if (url) {
      <img [src]="url" [alt]="name" />
    }
  </div>
}

@if (fileFormat === 'PDF') {
  <ngx-extended-pdf-viewer
    [src]="url"
    [showBorders]="false"
    [showToolbar]="false"
    [textLayer]="false"
    [sidebarVisible]="false"
    backgroundColor="#F7F7F7"
    [authorization]="true"
  ></ngx-extended-pdf-viewer>
}
